import lo from 'lodash';

export const buildUrl = (baseUrl = '', params = {}) => {
    return `${baseUrl}${buidlParams(params)}`;
}

export const buidlParams = (param = {}) => {
  const keys = Object.keys(param);
  if (lo.isEmpty(keys)) return '';
  return keys.reduce((str, key, index) => {
    if (index === 0) return `?${buildParam(key, param[key])}`;
    return `${str}&${buildParam(key, param[key])}`;
  }, '');
};

const buildParam = (key, value) => {
  if (value === null || value === undefined) return '';
  if (lo.isArray(value)) {
    return value.reduce(
      (str, cur, index) =>
        index === 0 ? createParam(key, cur) : `${str}&${createParam(key, cur)}`,
      ''
    );
  }

  return createParam(key, value);
};

const createParam = (key, value) => {
  return `${key}=${encodeURIComponent(value)}`;
};
